var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{staticClass:"AppTextArea",class:( _obj = {}, _obj[("has-status-" + _vm.status)] = _vm.status, _obj ),attrs:{"placeholder":_vm.placeholder,"rows":"10","maxlength":"500"},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }